import { LoadingSpinner } from '@expressable/syntax-ds';
import { DocumentTitle } from 'components/DocumentTitle';
import { SignupDirectContext, useSignupDirect } from 'domains/signupDirect/context';
import { withDisplayTimezone } from 'domains/timezone/useDisplayTimezone';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

const SignupDirect = () => {
  const ctxValue = useSignupDirect();

  const { t } = useTranslation();

  return (
    <>
      {/* @TODO move styles to syntax */}

      <DocumentTitle>{t('screener.pageTitle')}</DocumentTitle>
      <SignupDirectContext.Provider value={ctxValue}>
        {ctxValue.isLoadingSavedData ? <LoadingSpinner message="Loading..." /> : <Outlet />}
      </SignupDirectContext.Provider>
    </>
  );
};

export default withDisplayTimezone(SignupDirect);
